import React from 'react';
import Select from 'react-select';
import ReactToggle from 'react-toggle';
import clone from 'clone';
import classNames from 'classnames';
import CategoryActions from './action/categoryActions';
import CategoryStore from './store/categoryStore';
import BuildActions from '../builder/action/builderActions';
import panelActions from './action/panelActions';
import { findIndex } from 'underscore';
import GridSelect from '../element/gridselect';
import TaxonomySelection from '../helper/taxonomySelection';


class CategoryPanel extends React.Component {
    constructor(props) {
      super(props);
      this.metakey = '_reactive_builder_' + this.props.shortcodeKey;
      this.handleSubmiCategory = this.handleSubmiCategory.bind(this);
      this.handleTaxonomy = this.handleTaxonomy.bind(this);
      this.loadSettings = this.loadSettings.bind(this);
      this.valueIncrement = this.valueIncrement.bind(this);
      this.valueDecrement = this.valueDecrement.bind(this);
      this.valueIncrementLayout = this.valueIncrementLayout.bind(this);
      this.valueDecrementLayout = this.valueDecrementLayout.bind(this);
      this.handleLoadMoreButton = this.handleLoadMoreButton.bind(this);
      this.handleCheckedCategoryTemplate = this.handleCheckedCategoryTemplate.bind(this);
      this.state = {
        settings: {
          numberOfCategories: 6,
          loadMoreOption: false,
          desktop_hd: 2,
          desktop: 2,
          tablet: 1,
          mobile: 1,
        },
      };
    }
    componentWillMount() {
      this.loadSettings(this.props);
    }
    componentWillReceiveProps(nextProps) {
      this.loadSettings(nextProps);
    }
    loadSettings(props) {
      const allLayout = props.allLayout;
      let categoryTemplate = [];
      this.FlagCategoryTemplate = false;
      const find = findIndex(allLayout, { uid: this.props.uid });
      if (find !== -1) {
        let settings = {};
        if (allLayout[find].categorySettings) {
          settings = allLayout[find].categorySettings;
        }
        if (!settings.hasOwnProperty('termName')) {
          settings.termName = null;
        }
        // Categorey Template  value assigning starts
        if (!settings.hasOwnProperty('categoryTemplate')) {
          for (const key in ReactiveCategoryTemplate) {
            if (ReactiveCategoryTemplate.hasOwnProperty(key)) {
              const temp = {};
              temp.key = key;
              temp.value = ReactiveCategoryTemplate[key];
              if (settings.categoryTemplate !== key.toString()) {
                temp.isChecked = false;
              } else {
                this.FlagCategoryTemplate = true;
                temp.isChecked = true;
              }
              categoryTemplate.push(temp);
            }
          }
        } else {
          this.FlagCategoryTemplate = true;
          categoryTemplate = settings.categoryTemplate;
        }
        if (this.FlagCategoryTemplate === false) {
          const index = findIndex(categoryTemplate, { key: 'default' });
          if (index !== -1) {
            categoryTemplate[index].isChecked = true;
          }
        }
        settings['categoryTemplate'] = categoryTemplate;
        // Categorey Template  value assigning ends
        this.setState({
          settings : {
            ...this.state.settings,
            ...settings,
          },
          'allLayout': clone(this.props.allLayout),
        });
      }
    }
    saveSettingsData(key, value) {
      const { settings } = this.state;
      if (key === 'layout') {
        const allLayout = clone(this.props.allLayout);
        const index = findIndex(allLayout, { uid: this.props.uid });
        if (index !== -1) {
          allLayout[index].layout = value;
          settings[key] = value;
          this.setState({ settings, allLayout });
        }
      } else {
        settings[key] = value;
        this.setState({ settings });
      }
    }
    handleSubmiCategory() {
      const allLayout = clone(this.state.allLayout);
      const find = findIndex(allLayout, { uid: this.props.uid });
      if (find !== -1) {
        allLayout[find]['categorySettings'] = clone(this.state.settings);
      }
      const pushLayout = {
        allLayout,
        'shortcodeKey': this.props.shortcodeKey,
      };
      BuildActions.saveAllBlocks(pushLayout);
      panelActions.togglePanel('', this.props.shortcodeKey);
    }
    handleTaxonomy(termName) {
      const { settings } = this.state;
      settings['termName'] = termName;
      this.setState({ settings });
    }
    valueIncrement() {
      let value = null;
      if (this.state.settings.numberOfCategories !== undefined) {
        value = parseInt(this.state.settings.numberOfCategories, 10);
      } else {
        value = 5;
      }
      value += 1;
      this.saveSettingsData('numberOfCategories', value);
    }
    valueDecrement() {
      let value = null;
      if (this.state.settings.numberOfCategories !== undefined) {
        value = parseInt(this.state.settings.numberOfCategories, 10);
      } else {
        value = 5;
      }
      if (value === 0) {
        return;
      }
      value -= 1;
      this.saveSettingsData('numberOfCategories', value);
    }
    valueIncrementLayout() {
      let value = null;
      if (this.state.settings.layout !== undefined) {
        value = parseInt(this.state.settings.layout, 10);
      } else {
        value = 12;
      }
      if ((value + 1) > 12) {
        return;
      }
      value += 1;
      this.saveSettingsData('layout', value);
    }
    valueDecrementLayout() {
      let value = null;
      if (this.state.settings.layout !== undefined) {
        value = parseInt(this.state.settings.layout, 10);
      } else {
        value = 12;
      }
      if ((value - 1) < 1) {
        return;
      }
      value -= 1;
      this.saveSettingsData('layout', value);
    }
    handleCategoreyValueIncrement(element) {
      let value = null;
      if (this.state.settings[element] !== undefined) {
        value = parseInt(this.state.settings[element], 10);
      } else {
        value = 2;
      }
      if (element === 'desktop_hd') {
        if ((value + 1) > 4) {
          return;
        }
      } else if (element === 'desktop') {
        if ((value + 1) > 4) {
          return;
        }
      } else if (element === 'tablet') {
        if ((value + 1) > 3) {
          return;
        }
      } else if (element === 'mobile') {
        if ((value + 1) > 2) {
          return;
        }
      }
      value += 1;
      this.saveSettingsData(element, value);
    }
    handleCategoreyValueDecrement(element) {
      let value = null;
      if (this.state.settings[element] !== undefined) {
        value = parseInt(this.state.settings[element], 10);
      } else {
        value = 2;
      }
      if ((value - 1) < 1) {
        return;
      }
      value -= 1;
      this.saveSettingsData(element, value);
    }
    handleCheckedCategoryTemplate(e) {
      const categoryTemplate = this.state.settings.categoryTemplate;
      const allLayout = clone(this.props.allLayout);
      const index = findIndex(allLayout, { uid: this.props.uid });
      if (index !== -1) {
        categoryTemplate.map((item) => {
          if (item.value === e.target.value.toString()) {
            if (item.isChecked === 'false' || item.isChecked === false) {
              item.isChecked = true;
            } else {
              item.isChecked = false;
            }
          } else {
            item.isChecked = false;
          }
        });
      }
      this.saveSettingsData('categoryTemplate', categoryTemplate);
    }
    handleLoadMoreButton() {
      if (this.state.settings.loadMoreOption === 'false' || this.state.settings.loadMoreOption === false ){
        this.saveSettingsData('loadMoreOption', true);
      } else {
        this.saveSettingsData('loadMoreOption', false);
      }
    }
    render() {
      const self = this;
      const showCategoryTemplate = (item, index) => {
        return (<li className="search-content" key={'categorypanel-' + index}>
          <input type="radio" name="search-categoreyElement" checked={item.isChecked === true || item.isChecked === 'true'} id={'categoryStyle-' + index} value={item.value}
            onChange={this.handleCheckedCategoryTemplate}
          />
          <label className="select-search-content" htmlFor={'categoryStyle-' + index}>
            <span>{item.key}</span>
          </label>
        </li>);
      };
      return (<div>
        <button className="layout-save-button" onClick={this.handleSubmiCategory}><i className="fa fa-floppy-o"></i><span>{API.LANG.SAVE}</span></button>
        <div className="reactive-tab-setting">
          <ul className="nav nav-tabs" role="tablist">
            <li role="presentation" className="active"><a href="#general" aria-controls="general" role="tab" data-toggle="tab">{API.LANG.SETTINGS}</a></li>
            { this.state.settings.termName && <li role="presentation">
                <a href="#appearance" aria-controls="layout" role="tab" data-toggle="tab">{API.LANG.APPEARANCE}</a>
              </li>
            }
            { this.state.settings.termName && <li role="presentation">
                <a href="#styles" aria-controls="styles" role="tab" data-toggle="tab">{API.LANG.LAYOUT}</a>
              </li>
            }
            { this.state.settings.termName && <li role="presentation">
                <a href="#options" aria-controls="options" role="tab" data-toggle="tab">{API.LANG.OPTIONS}</a>
              </li>
            }
          </ul>
          <div className="tab-content">
            <div role="tabpanel" className="tab-pane active" id="general">
              <TaxonomySelection onTaxonomySelection={this.handleTaxonomy} value={this.state.settings.termName} {...this.props} />
            </div>
            { this.state.settings.termName && <div role="tabpanel" className="tab-pane" id="appearance">
                <div className="flex-row">
                  <div className="flex-sm-6">
                    <div className="grid-choose-option">
                      <div className="flex-row">
                        <div className="flex-sm-3 flex-xs-12">
                          <span className="caption">{API.LANG.NUMBER_OF_CATEGOREY}</span>
                        </div>
                        <div className="flex-sm-9 flex-xs-12">
                          <p><button onClick={ this.valueIncrement }><i className="fa fa-plus"></i></button></p>
                          <p><button onClick={ this.valueDecrement }><i className="fa fa-minus"></i></button></p>
                          <p className="gird-value-count">
                            { this.state.settings.numberOfCategories !== undefined ? this.state.settings.numberOfCategories : 5 }
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="grid-choose-option">
                      <div className="flex-row">
                        <div className="flex-sm-3 flex-xs-12">
                          <span className="caption">{API.LANG.CHANGE_CATEGOREY_LAYOUT}</span>
                        </div>
                        <div className="flex-sm-9 flex-xs-12">
                          <div className="choose-grid-button">
                            <p><button onClick={ this.valueIncrementLayout }><i className="fa fa-plus"></i></button></p>
                            <p><button onClick={ this.valueDecrementLayout }><i className="fa fa-minus"></i></button></p>
                            <p className="gird-value-count">
                              { this.state.settings.layout !== undefined ? this.state.settings.layout : 12 }
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="grid-choose-option no-padding">
                      <div className="flex-row">
                        <div className="flex-sm-3 flex-xs-12">
                          <span className="caption">{API.LANG.LOAD_MORE_TOGGLE}</span>
                        </div>
                        <div className="flex-sm-9 flex-xs-12">
                          <ReactToggle
                            defaultChecked={this.state.settings.loadMoreOption === 'true' || this.state.settings.loadMoreOption === true}
                            onChange={ this.handleLoadMoreButton }
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="flex-sm-6">
                    <div className="grid-choose-option">
                      <div className="flex-row">
                        <div className="flex-sm-3 flex-xs-12">
                          <span className="caption">{API.LANG.CATEGOREY_DESKTOP_HD}</span>
                        </div>
                        <div className="flex-sm-9 flex-xs-12">
                          <p><button onClick={ this.handleCategoreyValueIncrement.bind(this, 'desktop_hd') }><i className="fa fa-plus"></i></button></p>
                          <p><button onClick={ this.handleCategoreyValueDecrement.bind(this, 'desktop_hd') }><i className="fa fa-minus"></i></button></p>
                          <p className="gird-value-count">
                            { this.state.settings.desktop_hd !== undefined ? this.state.settings.desktop_hd : 2 }
                          </p>
                        </div>
                      </div>
                      <div className="flex-row">
                        <div className="flex-sm-3 flex-xs-12">
                          <span className="caption">{API.LANG.CATEGOREY_DESKTOP}</span>
                        </div>
                        <div className="flex-sm-9 flex-xs-12">
                          <p><button onClick={ this.handleCategoreyValueIncrement.bind(this, 'desktop') }><i className="fa fa-plus"></i></button></p>
                          <p><button onClick={ this.handleCategoreyValueDecrement.bind(this, 'desktop') }><i className="fa fa-minus"></i></button></p>
                          <p className="gird-value-count">
                            { this.state.settings.desktop !== undefined ? this.state.settings.desktop : 2 }
                          </p>
                        </div>
                      </div>
                      <div className="flex-row">
                        <div className="flex-sm-3 flex-xs-12">
                          <span className="caption">{API.LANG.CATEGOREY_TABLET}</span>
                        </div>
                        <div className="flex-sm-9 flex-xs-12">
                          <p><button onClick={ this.handleCategoreyValueIncrement.bind(this, 'tablet') }><i className="fa fa-plus"></i></button></p>
                          <p><button onClick={ this.handleCategoreyValueDecrement.bind(this, 'tablet') }><i className="fa fa-minus"></i></button></p>
                          <p className="gird-value-count">
                            { this.state.settings.tablet !== undefined ? this.state.settings.tablet : 1 }
                          </p>
                        </div>
                      </div>
                      <div className="flex-row">
                        <div className="flex-sm-3 flex-xs-12">
                          <span className="caption">{API.LANG.CATEGOREY_MOBILE}</span>
                        </div>
                        <div className="flex-sm-9 flex-xs-12">
                          <p><button onClick={ this.handleCategoreyValueIncrement.bind(this, 'mobile') }><i className="fa fa-plus"></i></button></p>
                          <p><button onClick={ this.handleCategoreyValueDecrement.bind(this, 'mobile') }><i className="fa fa-minus"></i></button></p>
                          <p className="gird-value-count">
                            { this.state.settings.mobile !== undefined ? this.state.settings.mobile : 1 }
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
            { this.state.settings.termName && <div role="tabpanel" className="tab-pane" id="styles">
                <div className="grid-choose-option">
                  <span className="caption">{API.LANG.SELECT_CATEGORY_TEMPLATE}</span>
                  <div>
                    <ul className="list-inline"> {this.state.settings.categoryTemplate !== undefined ? this.state.settings.categoryTemplate.map(showCategoryTemplate) : null}</ul>
                  </div>
                </div>
              </div>
            }
            { this.state.settings.termName && <div role="tabpanel" className="tab-pane" id="options">
             <div className="grid-choose-option no-padding">
                <div className="flex-row">
                  <div className="flex-sm-3 flex-xs-12">
                    <span className="caption">{API.LANG.LOAD_MORE_OPTION}</span>
                  </div>
                  <div className="flex-sm-9 flex-xs-12">
                    <input type="text" className="reactive-input" value={this.state.settings.viewMoreLink} onChange={ (node) => { self.saveSettingsData('viewMoreLink', node.target.value); }} />
                  </div>
                </div>
              </div>
              <div className="grid-choose-option no-padding">
                <div className="flex-row">
                  <div className="flex-sm-3 flex-xs-12">
                    <span className="caption">{API.LANG.WRAPPER_CLASS_CATEGORY}</span>
                  </div>
                  <div className="flex-sm-9 flex-xs-12">
                    <input type="text" className="reactive-input" value={this.state.settings.categoryWrapperClass} onChange={ (node) => { self.saveSettingsData('categoryWrapperClass', node.target.value); }} />
                  </div>
                </div>
              </div>
            </div>
            }
          </div>
        </div>
      </div>);
    }

}

CategoryPanel.propTypes = {
  'shortcodeKey': React.PropTypes.number,
  'uid': React.PropTypes.string,
  'allLayout': React.PropTypes.array,
};

export default CategoryPanel;
// roman sucks



/** WEBPACK FOOTER **
 ** ./assets/src/frontend/panel/categoryPanel.js
 **/